// extracted by mini-css-extract-plugin
export default {"product":"thumbImage_product__u9oce","activeSlide":"thumbImage_activeSlide__Fq8VK","thumbImage":"thumbImage_thumbImage__As3ma"};